import React from "react";

import { EdgeArrow } from "../components/EdgeArrow.tsx";
import EdiotorNav from "../../../Components/MyEditor/EdiotorNav.tsx";

type LogicLayoutProps = React.PropsWithChildren<{}>;

const LogicLayout = ({ children }: LogicLayoutProps) => {
    return (
        <div className="flex overflow-hidden relative flex-col px-4 h-screen text-left no-scrollbar">
            <EdiotorNav />
            <EdgeArrow />
            {children}
        </div>
    );
};

export default LogicLayout;
